import Header from "../sections/header";
import Scrollbar from "../components/scrollbar";
import Info from "../sections/info";
import Participate from "../sections/participate";
import Players from "../sections/players";
import History from "../sections/history";
import Footer from "../sections/footer";
import React from "react";
import {Link} from "react-router-dom";

export default function Datenschutz() {
    return (
        <div className={"min-h-[100vh] bg-gradient-to-b from-blue-light to-blue-dark flex flex-col gap-6 " +
            "overflow-y-hidden text-light"}>
            <Header/>
            <Scrollbar/>
            <div className="flex flex-col gap-6 px-2">
                <h1 className="text-3xl font-bold">Datenschutzerklärung für mcworld.run</h1>
                <div>
                    <p>Rafael Eisler</p>
                    <p>c/o Kartell07</p>
                    <p>Arbeitergasse 7</p>
                    <p>1050 Wien</p>
                    <p>Österreich</p>
                    <p>E-Mail: <a href="mailto://business@venicraft.at" className="underline">business@venicraft.at</a>
                    </p>
                </div>

                <div className="flex flex-col gap-2">
                    <h2 className="text-2xl font-bold my-2">Allgemeine Hinweise</h2>
                    <p>
                        Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten
                        daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003). In diesen
                        Datenschutzinformationen informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung
                        im Rahmen unserer Website und des Minecraft-Events.
                    </p>
                </div>

                <div className="flex flex-col gap-2">
                    <h2 className="text-2xl font-bold my-2">Verantwortlicher</h2>
                    <p>
                        Verantwortlich für die Datenverarbeitung auf dieser Website ist Rafael Eisler, c/o Kartell07,
                        Arbeitergasse 7, 1050 Wien, Österreich, E-Mail: <a href="mailto://business@venicraft.at"
                                                                           className="underline">business@venicraft.at</a>.
                    </p>
                </div>

                <div className="flex flex-col gap-2">
                    <h2 className="text-2xl font-bold my-2">Datenverarbeitung auf der Website</h2>
                    <p>
                        Beim Besuch unserer Website werden durch unseren Hosting-Dienstleister Cloudflare automatisch
                        folgende Daten verarbeitet:
                    </p>
                    <ul className="list-disc ml-6">
                        <li>IP-Adresse</li>
                        <li>Datum und Uhrzeit des Zugriffs</li>
                        <li>Abgerufene Seiten und Dateien</li>
                        <li>Browser-Informationen</li>
                    </ul>
                    <p>
                        Diese Daten werden zur technischen Bereitstellung, Sicherheit und Optimierung der Website
                        verarbeitet. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).
                    </p>
                    <p>
                        Empfänger der Daten ist Cloudflare Germany GmbH, Rosental 7, 80331 München, Deutschland. Es kann
                        eine Übermittlung in Drittländer erfolgen, die durch Standardvertragsklauseln abgesichert ist.
                    </p>
                </div>

                <div className="flex flex-col gap-2">
                    <h2 className="text-2xl font-bold my-2">Einsatz von Cookies</h2>
                    <p>
                        Auf unserer Website werden ausschließlich technisch notwendige Cookies eingesetzt. Es kommen
                        keine Tracking- oder Analyse-Tools zum Einsatz.
                    </p>
                </div>

                <div className="flex flex-col gap-2">
                    <h2 className="text-2xl font-bold my-2">Datenverarbeitung beim Minecraft-Event</h2>
                    <p>
                        Im Rahmen des Minecraft-Events werden folgende personenbezogene Daten verarbeitet:
                    </p>
                    <ul className="list-disc ml-6">
                        <li>IP-Adresse und Session ID (zur Authentifizierung)</li>
                        <li>UUID und Spielername (zur Identifikation im Spiel und für das Leaderboard)</li>
                        <li>Gelaufene Distanz (zur Auswertung und Veröffentlichung im Leaderboard)</li>
                    </ul>
                    <p>
                        Die Authentifizierung erfolgt über eine API, die auf Amazon Web Services (AWS) gehostet wird.
                        Die Datenübertragung erfolgt verschlüsselt. Nach Abschluss des Events werden UUID, Spielername
                        und gelaufene Distanz im Leaderboard auf der Website veröffentlicht.
                    </p>
                    <p>
                        Rechtsgrundlagen der Verarbeitung sind Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung, Teilnahme
                        am Event) und Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Durchführung und
                        Auswertung des Events).
                    </p>
                </div>

                <div className="flex flex-col gap-2">
                    <h2 className="text-2xl font-bold my-2">Speicherdauer</h2>
                    <p>
                        Die im Rahmen des Events erhobenen Daten werden nach Abschluss und Auswertung des Events
                        gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen. Die Daten im Leaderboard
                        bleiben öffentlich einsehbar, bis das Leaderboard entfernt wird.
                    </p>
                </div>

                <div className="flex flex-col gap-2">
                    <h2 className="text-2xl font-bold my-2">Ihre Rechte</h2>
                    <p>
                        Ihnen stehen grundsätzlich die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung,
                        Datenübertragbarkeit und Widerspruch zu. Sie können sich dazu jederzeit an uns wenden. Sie haben
                        zudem das Recht, sich bei der zuständigen Datenschutzaufsichtsbehörde zu beschweren.
                    </p>
                </div>

                <div className="flex flex-col gap-2">
                    <h2 className="text-2xl font-bold my-2">Kontakt zum Datenschutz</h2>
                    <p>
                        Bei Fragen zum Datenschutz wenden Sie sich bitte an: <a href="mailto://business@venicraft.at"
                                                                                className="underline">business@venicraft.at</a>
                    </p>
                </div>
            </div>
            <Footer/>
        </div>
    );
}